module.exports = __webpack_public_path__ + "img/program-about.420cd9ef.jpg";